import React from 'react';
import { ReactComponent as LogoSVG } from '../../logo.svg'; // Adjust path as needed

export const PageLoader = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-r from-customBlue-light to-customBlue">
      <div className="relative">
        <div className="w-64 h-64 rounded-full bg-white flex items-center justify-center animate-grow-animation">
          <LogoSVG className="w-48 h-48" />
        </div>
      </div>
    </div>
  );
};